module.exports = __webpack_public_path__ + "img/icon_login_qq@2x.c70b297a.png";